import React, { useState, useEffect, useContext } from 'react'
import { BoxCon, BoxScoreBottomRow, GameCon } from '../styles'
import {
  timeStampToDate,
  getPeriodAndClockTime,
  ClockTime,
} from '../../../Utils'
import { fetchEventInProgressBySlugGQL } from '../../../Api'
import type { EventGQL } from '../../../Api'
import { BoxScoreAction } from './BoxScoreAction'
import { BoxScoreInfo } from './BoxScoreInfo'
import { GeneralTeamRow } from './Teams/GeneralTeamRow'
import { BoxScoreTeam } from './Teams/BoxScoreTeam'
import { TeamScore } from './Teams/TeamScore'
import { BoxScoreStatus } from './BoxScoreStatus'
import { Broadcasters } from './Broadcast/Broadcasters'
import { LeagueContext } from '../../../Context'

type EventProps = {
  eventData: EventGQL
  teamId?: string
}

export const EventBox: React.FC<React.PropsWithChildren<EventProps>> = ({
  eventData,
}) => {
  const { updateEventInState } = useContext(LeagueContext)!
  let [date, setDate] = useState<string>()
  let [clockTime, setClockTime] = useState<ClockTime | null>()
  const awayTeam = eventData.awayTeam
  const homeTeam = eventData.homeTeam

  useEffect(() => {
    setHumanDate()
    if (eventData.eventStatus === 1) {
      console.log('Live event')
      getInProgressGameInfo(eventData.slugname)
      const interval = setInterval(() => {
        //Starting interval to go every 30 seconds
        getInProgressGameInfo(eventData.slugname).then((ev) => {
          if (!ev || ev?.eventStatus >= 2) {
            ev && updateEventInState(ev)
            clearInterval(interval)
            return
          }
        })
      }, 30000)
      return () => clearInterval(interval)
    }
    return
  }, [])
  
  const setHumanDate = () => {
    const time = timeStampToDate(eventData?.startTime)
    setDate(time.date)
  }

  const getInProgressGameInfo = async (slug: string) => {
    const updatedEventRes = await fetchEventInProgressBySlugGQL(slug)
    if (!updatedEventRes || !updatedEventRes?.event) {
      return
    }
    let ev = updatedEventRes.event
    ev = {...eventData, ...ev}
    const periodAndTime = getPeriodAndClockTime(ev)
    if (!periodAndTime) return
    setClockTime(periodAndTime)
    updateEventInState(ev)
    return ev
  }

  if (!eventData) {
    return <div />
  }

  return (
    <BoxCon>
      <BoxScoreInfo event={eventData} date={date} />
      <GameCon>
        <div className="teamsAndScoresCol">
          <div className="teamAndScoreRow">
            <>
              {!awayTeam?.officialId ? (
                <GeneralTeamRow />
              ) : (
                <BoxScoreTeam team={awayTeam} event={eventData} />
              )}
            </>
            {eventData?.eventStatus >= 1 && <TeamScore event={eventData} teamStatus="away" />}
          </div>

          <div className="teamAndScoreRow">
            <>
              {!homeTeam?.officialId ? (
                <GeneralTeamRow />
              ) : (
                <BoxScoreTeam team={homeTeam} event={eventData} />
              )}
            </>
            {eventData?.eventStatus >= 1 && <TeamScore event={eventData} teamStatus="home" />}
          </div>
        </div>
        <BoxScoreStatus
          event={eventData}
          period={clockTime?.period}
          clockTime={clockTime?.clockTime}
        />
      </GameCon>
      <BoxScoreBottomRow>
        <Broadcasters event={eventData} />
        <BoxScoreAction event={eventData} buttonText="View Stats" />
        <BoxScoreAction event={eventData} buttonText="Preview" />
      </BoxScoreBottomRow>
    </BoxCon>
  )
}
